import './Fotter.css'
import '../main_root.css'
import React from 'react'
import logo from '../../brand_logo.png'
import {Link} from 'react-router-dom'


const Fotter = () => {
  return (
<section className='Fotter'>
    <div className='container'>     
          <div className='intro'>
            <Link> <img src={logo} alt='logo'/> </Link>
            <p>SALE UP TO 70% OFF FOR ALL CLOTHES & FASHION ITEMS, ON ALL BRANDS.</p>  
              <ul>
                <li> <a href="https://www.facebook.com/"><i className="fa-brands fa-facebook-f"></i></a></li>
                <li> <a href="https://www.youtube.com/"><i className="fa-brands fa-youtube"></i></a></li>
                <li> <a href="https://www.linkedin.com/"><i className="fa-brands fa-linkedin"></i></a></li>
                <li> <a href="https://www.instagram.com/"><i className="fa-brands fa-instagram"></i></a></li>

            </ul>
          </div>  

        <div className='row'>

              <div className='col-lg-3 col-md-6'>
                  <h4>Our Links</h4>
                  <ul>
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/Apout">About us</Link> </li>  
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/Store">Store</Link> </li>  
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/CartPage">Cart</Link> </li>                        
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/ContactUs">Contact us</Link> </li>  
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/Privacy_Policy">Privacy Policy</Link> </li>  
                  </ul>  

              </div>               

              
              <div className='col-lg-3 col-md-6'>
                <h4>chanel</h4>
                  <ul>
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/Services">Services</Link> </li>  
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/Login">Login</Link> </li>  
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/Registration">Registration</Link> </li>  
                      <li> <i className="fa-solid fa-chevron-right"></i>  <Link to="/Checkout">Checkout</Link> </li>  
                  </ul>   
              </div>              
              

                    
              
              <div className='col-lg-3 col-md-6'>
                   <h4>Get in Touch With Us</h4>
                <ul className="d-flex">
                    <li><i className="fa-solid fa-location-dot"></i></li>
                    <li>130 El Tahrir Street,<br/> Shobra, Cairo, Egypt</li>
                </ul>

                <ul className="d-flex">
                    <li><i className="fa-solid fa-phone"></i></li>
                    <li>+010 979 499 99<br/>+015 526 879 99 </li>
                </ul>

                <ul className="d-flex">
                    <li><i className="fa-regular fa-envelope"></i></li>
                    <li>support@Shehap_samir.id
                        <br/>info@bookland.id
                    </li>
                </ul>
                  </div> 

                <div className='col-lg-3 col-md-6'>
                  <h4>Subscribe</h4>
                    <input type='email' placeholder='Your email address...'/>  
                    <button>Subscribe</button>    
              </div>    

</div> 
          </div> 
          <div className='lastFotter'>
                <p>Copyright © 2023 Brandstore. Powered by Shehap_samir.</p>
                
          </div>
    </section>
      
      
      
      
  )
}

export default Fotter